import { useState, useEffect } from "react";

import axiosInstance from "../../api/axios";

import DataTable from "../table/DataTable";
import Loading from "../../shared/Loading";

import "../../clients.css";

const columns = [
  { id: "id", label: "#" },
  // { id: "companyName", label: "Cég" },
  { id: "fullName", label: "Teljes név" },
  { id: "role", label: "Beosztás" },
  { id: "phoneNumber", label: "Telefonszám" },
  { id: "loginCode", label: "PIN kód" },
  { id: "activated", label: "Státusz" },
  { id: "action", label: "Művelet" },
];

const Clients = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosInstance
      .get("/api-admin/client")
      .then((response) => {
        setData(response.data.result);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <DataTable
      dataList={data}
      createButtonLink={"/create-client"}
      createButtonText={"Új felhasználó létrehozása"}
      editable={true}
      title={"Felhasználó lista"}
      columns={columns}
      operationLink={"edit-client"}
      loading={loading}
    />
  );
};

export default Clients;
